var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_810_1101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_810_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2 14C3.87 14 3.5875 13.8776 3.3525 13.6328C3.1175 13.388 3 13.0938 3 12.75V5.25C3 4.90625 3.1175 4.61198 3.3525 4.36719C3.5875 4.1224 3.87 4 4.2 4H13.8C14.13 4 14.4125 4.1224 14.6475 4.36719C14.8825 4.61198 15 4.90625 15 5.25V12.75C15 13.0938 14.8825 13.388 14.6475 13.6328C14.4125 13.8776 14.13 14 13.8 14H4.2ZM9 9.625L13.8 6.5V5.25L9 8.375L4.2 5.25V6.5L9 9.625Z",
    fill: "#A59696"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4d88b7fcbd02f9af71a021dc83cbe163.svg";
export { ForwardRef as ReactComponent };